import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Transition } from '@headlessui/react'

const LoginTransition = ({ children }) => {
    const [isShowing, setIsShowing] = useState(true)

    useEffect(() => {
        return () => {
            setIsShowing(false)
        }
    }, [])

    return (
        <Transition
            appear
            unmount={true}
            show={isShowing}
            className="w-full h-full"
        >
            <Transition.Child
                className="transition-all transform duration-500 ease-in overflow-hidden h-full"
                enterFrom="opacity-0 scale-90"
                enterTo="opacity-100 scale-100"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-90"
            >
                {children}
            </Transition.Child>
        </Transition>
    )
}

LoginTransition.propTypes = {
    children: PropTypes.element,
}

export default LoginTransition
